import { Bookmark } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import env from "@/env";

type SavedInConfigMarkerProps = {
  className?: string;
  /** Show a short text label next to the icon (e.g. in denser rows). */
  showLabel?: boolean;
};

/** Marks form sections/fields that are included when the user saves a deployment configuration. */
export const SavedInConfigMarker: React.FC<SavedInConfigMarkerProps> = ({
  className,
  showLabel = false
}) => {
  if (!env.FEATUREFLAG_SAVED_DEPLOYMENT_CONFIGS) {
    return null;
  }

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              "inline-flex items-center gap-1 rounded-md border border-border bg-muted/50 px-1.5 py-0.5 text-muted-foreground",
              className
            )}
            aria-label="Included when you save a configuration"
          >
            <Bookmark className="h-3 w-3 shrink-0" />
            {showLabel ? (
              <span className="text-[11px] font-medium leading-none">Saved</span>
            ) : null}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[220px]">
          Included when you save a configuration
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
